 /*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file contains Error message and functions
 * that allow us to display error's data to the user
 * or to sign out the user if something is wrong with his session
 */

// Imports
import { toast } from 'react-toastify';

// Interfaces
import { Alert, AlertType } from '../../interfaces/IUtils';

// CSS
import 'react-toastify/dist/ReactToastify.css';

const ERROR_DISPLAY_TIME = 5;

// Handle alert
export const displayAlert = (alert: Alert = {message: '', type: AlertType.error}) => {
    console.log(alert);
    switch(alert.type) {
      case AlertType.error: toast.error(alert.message, {autoClose: ERROR_DISPLAY_TIME * 1000}); break;
      case AlertType.warning: toast.warn(alert.message, {autoClose: ERROR_DISPLAY_TIME * 1000}); break;
      case AlertType.success: toast.success(alert.message, {autoClose: ERROR_DISPLAY_TIME * 1000}); break;
      case AlertType.info:
      default:
        toast.info(alert.message, {autoClose: ERROR_DISPLAY_TIME * 1000}); break;
    }
  }



  /**
   * Cleans up the localStorage and process the callback
   * @author Mickaël "Naxe67" APPEL
   * @returns {void}
   * @since 2023-10-25
   */
export const signOut = (callback: Function) => {
    // Retrieve usefull data even after signing out
    const cabinetAlias = localStorage.getItem('cabinetAlias') || 'buroclic';
    const cabinet =localStorage.getItem('cabinet') || undefined;

    // Clear localStorage and store back all usefull data
    localStorage.clear();
    localStorage.setItem('cabinetAlias', cabinetAlias);
    if (cabinet) localStorage.setItem('cabinet', cabinet);

    // Will mainly navigate the user to the login page
    callback(cabinetAlias);
}



  export enum Error {
    'badParameters' = 'Bad parameters',
    'incorrectBody' = 'Incorrect body',
    'NoMatch' = 'Wrong credentials',
    'NotSignedIn' = 'You need to sign in first',
    'Forbidden' = 'Forbidden',
    'NotFound' = 'Not found',
    'PayloadTooLarge' = 'Payload Too Large',
    'UnsupportedMediaType' = 'Unsupported Media Type',
    'TooManyRequests' = 'Too Many Requests',
    'Unexpected' = 'Unexpected error',
  }

  export enum ErrorForUsr {
    'badParameters' = 'La requête n\'est pas supportée. Un paramètre est manquant ou son type est incorrect.',
    'incorrectBody' = 'Le corps de la requête n\'est pas conforme. Un champ est peut être manquant ou son type n\'est pas celui qui est attendu.',
    'NoMatch' = 'Vos éléments de connnexion sont incorrects',
    'NotSignedIn' = 'Vous n\'êtes pas connecté',
    'Forbidden' = 'Vous n\'avez pas les permissions nécessaires pour afficher cette ressource',
    'NotFound' = 'La ressource demandée est inexistante',
    'PayloadTooLarge' = 'Les éléments envoyés sont trop nombreux ou trop lourd',
    'UnsupportedMediaType' = 'Le media envoyé n\'est pas supporté',
    'TooManyRequests' = 'Dépassement de la limitation de requêtes autorisées',
    'Unexpected' = 'Une erreur inconnue est survenue. N\'hésitez pas à nous contacter pour nous signaler ce problème'
  }